import _sfc_main from "./VideoSettingTab.vue2.mjs";
/* empty css                      */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: ["video-tab", _setup.themeClass] }, [_c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Camera")))]), _c(_setup.DeviceSelect, { attrs: { "device-type": "camera" } })], 1), _vm.withPreview ? _c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Preview")))]), _vm._m(0)]) : _vm._e(), _c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Resolution")))]), _c(_setup.VideoProfile)], 1), _c("div", { staticClass: "mirror-container" }, [_c("span", [_vm._v(_vm._s(_setup.t("Mirror")))]), _c(_setup.TuiSwitch, { model: { value: _setup.isLocalStreamMirror, callback: function($$v) {
    _setup.isLocalStreamMirror = $$v;
  }, expression: "isLocalStreamMirror" } })], 1), _vm.withMore ? _c("div", { staticClass: "item-setting" }, [_c("div", { staticClass: "item", on: { "click": _setup.handleMoreCameraSetting } }, [_vm._v(" " + _vm._s(_setup.t("More Camera Settings")) + " ")])]) : _vm._e()]);
};
var _sfc_staticRenderFns = [function() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { staticClass: "video-preview-container" }, [_c("div", { staticClass: "video-preview", attrs: { "id": "test-camera-preview" } })]);
}];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "2322ab50"
);
const VideoSettingTab = __component__.exports;
export {
  VideoSettingTab as default
};
